import { render, staticRenderFns } from "./navbox.vue?vue&type=template&id=3cdbbde2&scoped=true&"
import script from "./navbox.vue?vue&type=script&lang=js&"
export * from "./navbox.vue?vue&type=script&lang=js&"
import style0 from "./navbox.vue?vue&type=style&index=0&id=3cdbbde2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbbde2",
  null
  
)

export default component.exports